export default __webpack_public_path__ + "static/media/join.0c617465.svg";